import CommonUtil from "../utils/CommonUtil";

class RegistrationValidator {
  validate(
    username,
    password,
    passwordConfirm,

    enablement
  ) {
    const validationArray = this.constructArrayForValidation(
      username,
      password,
      passwordConfirm,

      enablement
    );

    const notEmptyValidation = CommonUtil.isEveryStringNotEmpty(
      validationArray
    );

    return notEmptyValidation;
  }

  constructArrayForValidation(
    username,
    password,
    passwordConfirm,

    enablement
  ) {
    var map = {
      username: username,
      password: password,
      passwordConfirm: passwordConfirm
    };
    var array = [];
    for (let key in map) {
      if (enablement[key]) {
        array.push(map[key]);
      }
    }
    return array;
  }
}

export default RegistrationValidator;
